import HttpFactory from '../factory'
import type { RelationshipInterface, Person } from '../types/patient/relationship'

class PersonModule extends HttpFactory<any[]> {
  private PATH = 'persons'

  async getRelationShip(id: string): Promise<RelationshipInterface[]> {
    return await this.call<any>('GET', `/${this.PATH}/${id}/relationships`)
  }

  async get(id: string): Promise<Person> {
    return await this.call<any>('GET', `/${this.PATH}/${id}`)
  }

  async getCurrentPlace(personId: string): Promise<Person> {
    return await this.call<any>('GET', `/places?usedById=${personId}&usedByType=person`)
  }

  async patchAdditionalInformation(data: Person): Promise<Person> {
    return await this.call<any>('PATCH', `/${this.PATH}/${data.id}?revision=${data.revision}`, {
      additionalInformation: data.additionalInformation,
    })
  }

  async updateCurrentPlace(personId: string, placeId: string): Promise<Person> {
    return await this.call<any>('PUT', `/${this.PATH}/${personId}/current-place/${placeId}`)
  }

  async save(data: Person): Promise<Person> {
    if (data.id) {
      return this.call<any>('PATCH', `${this.PATH}/${data.id}?revision=${data.revision}`, {
        gender: data.gender,
        firstName: data.firstName,
        lastName: data.lastName,
        additionalInformation: data.additionalInformation,
      })
    } else {
      return await this.call<any>('POST', `/${this.PATH}`, data)
    }
  }
}

export default PersonModule
